import {Component, OnInit} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {DocumentService} from "../../shared/services/document.service";
import {Subject} from "rxjs";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  logo = '';
  destroy$ = new Subject<void>();

  constructor(private documentService: DocumentService) {
  }

  ngOnInit(): void {
    this.getLogo()
  }

  getLogo() {
    this.logo = this.documentService.getLogoPage();
    if (!this.logo) {
      this.documentService.getLogo().pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
          this.logo = res.logo;
          this.documentService.setLogoPage(this.logo);
        }
      })
    }
  }
}
